/**
 * Proto DTO identity for UUID-primary records (`BaseUuidEntity`).
 */
export abstract class BaseProtoUuidDto {
  uuid!: string;
}
